import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedSeccionsocios,
  addingSeccionsocios,
  addingSeccionsociosFailed,
  editedSeccionsocios,
  editingSeccionsocios,
  editingSeccionsociosFailed,
  foundSeccionsocios,
  loadedSeccionsocios,
  loadingSeccionsocios,
  loadingSeccionsociosFailed,
  removedSeccionsocio,
  removingSeccionsocio,
  removingSeccionsocioFailed,
  searchingSeccionsocios,
  searchingSeccionsociosFailed,
  SeccionsociosAction,
  SeccionsociosActionTypes,
  softRemovedSeccionsocios,
  softRemovingSeccionsocios,
  softRemovingSeccionsociosFailed,
} from '../actions/seccionsociosActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.SEARCH_SECCIONSOCIOS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/seccionsocios/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundSeccionsocios(response.data, action.keep)),
        startWith(searchingSeccionsocios()),
        catchError(() => of(searchingSeccionsociosFailed()))
      )
    })
  )

const loadSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.LOAD_SECCIONSOCIOS)),
    switchMap((action) => {
      let url = `${API_URL}/api/seccionsocios/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedSeccionsocios(response.data)),
        startWith(loadingSeccionsocios()),
        catchError(() => of(loadingSeccionsociosFailed()))
      )
    })
  )
}

const addSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.ADD_SECCIONSOCIOS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/seccionsocios/`, data, config)).pipe(
        map((response) => addedSeccionsocios(response.data)),
        startWith(addingSeccionsocios()),
        catchError((err) => of(addingSeccionsociosFailed(err.response)))
      )
    })
  )

const removeSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.REMOVE_SECCIONSOCIO)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionsocios/${action.payload._id}`)).pipe(
        map((response) => removedSeccionsocio()),
        startWith(removingSeccionsocio()),
        catchError(() => of(removingSeccionsocioFailed()))
      )
    )
  )

const softRemoveSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.SOFT_REMOVE_SECCIONSOCIOS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionsocios/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedSeccionsocios(response.data.record)),
        startWith(softRemovingSeccionsocios()),
        catchError((err) => of(softRemovingSeccionsociosFailed(err.response)))
      )
    )
  )

const editSeccionsociosEpic: Epic<SeccionsociosAction, SeccionsociosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionsociosActionTypes.EDIT_SECCIONSOCIOS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/seccionsocios/${action.payload._id}`, data, config)).pipe(
        map((response) => editedSeccionsocios(response.data)),
        startWith(editingSeccionsocios()),
        catchError((err) => of(editingSeccionsociosFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchSeccionsociosEpic,
  loadSeccionsociosEpic,
  addSeccionsociosEpic,
  removeSeccionsociosEpic,
  softRemoveSeccionsociosEpic,
  editSeccionsociosEpic
)
